import { REACT_APP_ADPM_API_KEY, REACT_APP_KEYCLOAK_REALM  } from '../config';
import {  reservedPortFromCTX } from '../utility/contextUtility';
import { get, post } from '../utility/http';

export async function fetchFlights(ctx: string) {
  try {
    
 
    const response : any = await get(
      `/tasks/tasks/ctx/${ctx}?type=drone-mission&active=true&projection=EPSG:3857`,
      true, {}, false, true
    );

     
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

 

export async function uploadIcon(
  ctx: string,
  fileSelected: any ){

  /*console.log('uploadIcon');
  console.log(ctx);
  console.log(fileSelected);*/
  // Create an object of formData
  const formData = new FormData();

  // Update the formData object
  formData.append(
    'file',
    fileSelected,
    fileSelected.name
  );
  //console.log(formData);
  const response = await post(
    `/files/icons/ctx/${ctx}/upload`,
    true,
    {},
    formData,
    false,
    true,
    'multipart/form-data',
    240000
  );
  return response;
}


export async function uploadIconDefault(
  ctx: string,
  fileSelected: any ){

  /*console.log('uploadIcon');
  console.log(ctx);
  console.log(fileSelected);*/
  // Create an object of formData
  const formData = new FormData();

  // Update the formData object
  formData.append(
    'file',
    fileSelected,
    fileSelected.name
  );
  //console.log(formData);
  const response = await post(
    `/files/icons/ctx/${ctx}/uploadDefault`,
    true,
    {},
    formData,
    false,
    true,
    'multipart/form-data',
    240000
  );
  return response;
}
 
export async function changeCylinder( 
  ctx: string,
  jobId: string,
  uavId: string,
  radius: number,
  height: number
) {
   
  let url2 = `/tracks/updateConflictArea?ctx=${ctx}&jobId=${jobId}`;
  url2 += `&uavId=${uavId}&radius=${radius}&height=${height}`;
  try {
    const response = await post(
      url2,
      true,
      {},
      {},
      false,
      true
    );

     
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}




export async function joinIconToJob( 
  jobId: string,
  iconId: string
) {
   
  const url2 = `/tasks/jobs/icon/${jobId}?iconId=${iconId}`;
  try {
    const response = await get(
      url2,
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}



export async function joinCylinderToTask( 
  jobId: string,
  radius: number,
  height: number
) {
   
  const url2 = `/tasks/jobs/cylinder/${jobId}?radius=${radius}&height=${height}`;
  try {
    const response = await get(
      url2,
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}


export async function fetchDroneTracker(
  uavId: string,
  type: string,
  jobId: string,
  ctx: string
) { 
  const url1 =  `uavId=${uavId}&type=${type}&jobId=${jobId}&ctx=${ctx}&projection=3857`;
  const url2 = `/tracks/last?${url1}`;
  try {
    const response = await get(
      url2,
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}




export async function fetchDronesTracker( 
  ctx: string,
  mineOnly: boolean
) {
  const url2 = `/tracks/lastTracks?ctx=${ctx}&mineOnly=${mineOnly}&projection=3857`;
  try {
    const response = await get(
      url2,
      true,
      {},
      false,
      true
    );     
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}



export async function fetchDronesNearTracker( 
  ctx: string ,
  uavId: string ,
  radius: number ,
) {
  const url2 = 
  `/tracks/getNearDrones?ctx=${ctx}&uavId=${uavId}&radius=${radius}&projection=EPSG:3857`;
  try {
    const response = await get(
      url2,
      true,
      {},
      false,
      true
    );     
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}
export async function fetchIcons( 
  ctx: string
) {
  const url2 = `/files/icons/ctx/${ctx}/info`;
  try {
    const response = await get(
      url2,
      true,
      {},
      false,
      true
    );     
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}


export async function fetchDronesConflict( 
  ctx: string
) { 
  const url2 = `/tracks/getConflictingTracks?ctx=${ctx}&projection=EPSG:3857`;
  try {
    const response = await get(
      url2,
      true,
      {},
      false,
      true
    );     
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchDronePositionPull(uavId: string, hangarIdentifier: string) {
  try {
    if(hangarIdentifier && hangarIdentifier.length > 0)
    {
      const response = await get(
        `/hangar/hangar/${hangarIdentifier}/drone?id=${uavId}`,
        true,
        {},
        false,
        true
      );
      return response;
    }
    else
    {
      const response = await get(
        `/tpz/drone?id=${uavId}&apikey=${REACT_APP_ADPM_API_KEY}`,
        true,
        {},
        false,
        true
      );
      return response;
    }
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchDroneState({ id, hangarIdentifier }:
    { id: any, hangarIdentifier: string }) {
  try {
    if(hangarIdentifier && hangarIdentifier.length > 0)
    {
      const response = await get(
        `/hangar/hangar/${hangarIdentifier}/drone?id=${id}`,
        true,
        {},
        false,
        true
      );
      return response;
    }
    else
    {
      const response = await get(
        `/tpz/drone?id=${id}&apikey=${REACT_APP_ADPM_API_KEY}`,
        true,
        {},
        false,
        true
      );
      return response;
    }
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchDroneControl({ cmd, uav_id, hangarIdentifier, ...rest }: any) {
  try {
    if(hangarIdentifier && hangarIdentifier.length > 0)
    {
      const response = await post(
        `/hangar/hangar/${hangarIdentifier}/drone`,
        true,
        {},
        {
          cmd,
          uav_id,
          ...rest
        },
        false,
        true
      );
      return response;
    }
    else
    {
      const response = await post(
        `/tpz/drone?apikey=${REACT_APP_ADPM_API_KEY}`,
        true,
        {},
        {
          cmd,
          uav_id,
          ...rest
        },
        false,
        true
      );
      return response;
    }
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}


export async function fetchMavlinkControlGet({
  cmd,
  uav_id, 
  ...rest
}: any) {
  try {
    
     
    const response = await get(
      `/mavlink-srv/services/port_${reservedPortFromCTX()}/${cmd}`,
      true,
      { uav_id, ...rest },
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchMavlinkControlPost({
  cmd,
  uav_id,
  offset, 
  ...rest
}: any) {
  try {
    
    const response = await post(
      `/mavlink-srv/services/port_${reservedPortFromCTX()}/${
        cmd === 'loadmission' ? 'upload_mission' : 'goto_loc'
      }`,
      true,
      { uav_id },
      {
        cmd,
        uav_id,
        offset,
        ...rest
      },
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchMavlinkInitialized({ uav_id  }: any) {
  try {
     
    const response = await get(
      `/mavlink-srv/services/port_${reservedPortFromCTX()}/initialized?uav_id=${uav_id}`,
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchHangar(hanId: any, hangarIdentifier: string) {
  try {
    if(hangarIdentifier && hangarIdentifier.length > 0)
    {
      const response = await get(
        `/hangar/hangar/${hangarIdentifier}/hangar`,
        true,
        {},
        false,
        true
      );
      return response;
    }
    else
    {
      const response = await get(
        `/tpz/hangar?id=${hanId}&apikey=${REACT_APP_ADPM_API_KEY}`,
        true,
        {},
        false,
        true
      );
      return response;
    }
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchHangarControl({ hangar, hanId, hangarIdentifier }: any) {
  try {
    if(hangarIdentifier && hangarIdentifier.length > 0)
    {
      const response = await post(
        `/hangar/hangar/${hangarIdentifier}/hangar`,
        true,
        {},
        {
          hangar,
          hanId
        },
        false,
        true
      );
      return response;
    }
    else
    {
      const response = await post(
        `/tpz/hangar?apikey=${REACT_APP_ADPM_API_KEY}`,
        true,
        {},
        {
          hangar,
          hanId
        },
        false,
        true
      );
      return response;
    }
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchCleosList() {
  try {
    const response = await get(
      '/sedge-api/getDetectionsList',
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchStartCleosStream({
  uav_id,
  video_url,
  which_detection,
  model,
  runId
}: {
  uav_id: string;
  video_url: string,
  which_detection: string[];
  model: string;
  runId: string;
}) {
  try {

    
    const response = await post(
      '/sedge-api/startDetection ',
      true,
      {},
      { 
        uav_id: uav_id, 
        video_url: video_url,
        which_detection: which_detection, 
        host_name:  REACT_APP_KEYCLOAK_REALM,
        model: model,
        runId: runId
      },
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchStopCleosStream(uav_id: string, video_url: string, 
  which_detection: string[]) {
  try {
    const response = await post(
      '/sedge-api/stopDetection ',
      true,
      {},
      { uav_id, video_url, which_detection },
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchGeolocation({
  uav_id,
  which_detection
}: {
  uav_id: string;
  which_detection: string[];
}) {
  try { 
    let url = `/sedge-api/getGeolocations?uavId=${uav_id}`;
    which_detection.forEach((detc: string)=>{
      url += `&which_detection=${detc}`;
    });
    const response = await get(url,
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchCleosActiveStreams() {
  try {
    const response = await get(
      '/sedge-api/getActiveDetections',
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function linkTask(uavId: any, taskId: any, ctx: any, taskLabel: string,
  job_id: string,
  radius: any, height: any) {
  try {
    const response = await post(
      '/tracks/link',
      true,
      { uavId: uavId, taskId: taskId, ctx: ctx, taskLabel: taskLabel, 
        radius: radius, height: height, jobId: job_id },
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function unlinkTask(uavId: any, taskId: any, ctx: any) {
  try {
    const response = await post(
      '/tracks/unlink',
      true,
      { uavId: uavId, taskId: taskId, ctx: ctx },
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

/*Questo servizio non viene più chiamato*/
export async function checkTask(uavId: any, taskId: any, ctx: any, jobId: any) {
  try {
    const response = await get(
      '/tracks/check',
      true,
      { uavId: uavId, taskId: taskId, ctx: ctx, jobId: jobId },
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function linkJob(uavId: any, jobId: any, droneIdentifier: any, ctx: any, jobLabel: any,
  radius: any, height: any, isResume: boolean) {
  try {
    const response = await post(
      '/tracks/link',
      true,
      { uavId: uavId, jobId: jobId, droneIdentifier: droneIdentifier, ctx: ctx, jobLabel: jobLabel,
        radius: radius, height: height, resume: isResume },
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function lastPosJob(jobId: any, ctx: any) {
  try {
    const response: any = await get(
      '/tracks/lastJobItem',
      true,
      {jobId: jobId, ctx: ctx},
      false,
      true
    );
    return response?.data;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function unlinkJob(uavId: any, jobId: any, ctx: any) {
  try {
    const response = await post(
      '/tracks/unlink',
      true,
      { uavId: uavId, jobId: jobId, ctx: ctx },
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function checkJob(uavId: any, jobId: any, ctx: any) {
  try {
    const response = await get(
      '/tracks/check',
      true,
      { uavId: uavId, jobId: jobId, ctx: ctx },
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchSocketConnected(uavId: any, username: any) {
  try {
    const response = await get(
      `/websocket/api/${uavId}/${username}`,
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchRestartService(serviceName: string) {
  try {
    const response = await post(`/dm/restart?name=${serviceName}&state=all`, true);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}


export async function fetchHomePosition(uavId: string, ctx: any, droneIdentifier: string) {
  try {
    const response: any = await get(
      `/tracks/getHomePosition?ctx=${ctx}&uavId=${uavId}&droneIdentifier=${droneIdentifier}`,
      true,
      {},
      false,
      true
    );
    return response?.data?.coordinates
      && response?.data?.coordinates.length == 3 ? response?.data.coordinates[2] : 0;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}
